import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NavLink from './components/NavLink.jsx';
import AppSearchResults from './components/AppSearchResults/AppSearchResults';

import moment from 'moment';
import { connect } from 'react-redux';
import {
  setLoggedInUser,
  userWasConnected,
  userWasDisconnected,
} from './actions/appState';
import { GeckoAvatar, GeckoModalService } from './ui';
import { renderError } from 'services/gecko-error';
import AppSearch from './components/AppSearch/AppSearch.jsx';
import AccountSwitcherModal from './components/AccountSwitcherModal.jsx';
import AvailabilityModal from './components/AvailabilityModal';
import GeckoFeatures from 'services/gecko-features';
import GeckoPermissions from 'services/gecko-permissions';
import {
  newConversation,
  updateConversation,
  fetchMyConversations,
  fetchUnassignedConversations,
  fetchOpenConversations,
  fetchClosedConversations,
  fetchSentConversations,
  fetchBotInterferenceConversations,
  fetchSavedCustomFiltersDetails,
  fetchCustomFilter,
  fetchAllSavedCustomFilters,
  fetchUndeliveredMessagesConversations,
  fetchConversationCounts,
  handleMergedContacts,
} from 'routes/conversations/actions';
import { fetchBots } from './routes/bots/actions';
import { CONSTS } from 'constants/index';
import GeckoSocket from 'services/gecko-socket';
import AccountSwitcher from './services/account-switcher';
import TagManager from 'react-gtm-module';
import { getShowNavBarBack, getMessagesActive } from './reducers/uiSelector';
import classNames from 'classnames/bind';
import { showMessages, showChatHeads } from './actions/ui';
import SetupWidgets from 'services/setup-widgets';
import logo from './logo.png';
import UserAvailability from './utilities/userAvailability';
import PresenceBadge from '../src/components/PresenceBadge';
import getPresence from './utilities/getPresence';

class App extends Component {
  constructor(props) {
    super(props);
    this.appNavMenu = React.createRef();
    this.state = {
      menuIsOpen: false,
      disableMenuButton: false,
    };
  }

  UNSAFE_componentWillMount() {
    // We want to keep conversations up to date regardless as to what page were on so we know of new messages
    GeckoSocket.on('conversation:created', newConversation);
    GeckoSocket.on('conversation:updated', updateConversation);
    GeckoSocket.on('contacts:merged', handleMergedContacts);

    GeckoSocket.on('disconnect', this.props.userWasDisconnected);
    GeckoSocket.on('reconnect', this.props.userWasDisconnected);
    GeckoSocket.on('connect', this.props.userWasConnected);

    const { apiUrl } = this.props;
    const region = this.getRegion(apiUrl);

    Promise.all([
      fetchMyConversations(),
      fetchUnassignedConversations(),
      fetchOpenConversations(),
      fetchClosedConversations(),
      fetchSentConversations(),
      fetchBotInterferenceConversations(),
      fetchCustomFilter(),
      fetchSavedCustomFiltersDetails()
        .then(fetchAllSavedCustomFilters)
        .then(fetchConversationCounts),
      fetchUndeliveredMessagesConversations(),
      fetchBots(),
      SetupWidgets(region),
    ]).catch(console.error);
  }

  componentDidMount() {
    const { loggedInUser, apiUrl } = this.props;
    const dataLayer = {
      event: 'logged_in',
      userId: loggedInUser.id,
      userType: loggedInUser.type,
      userLastActive: loggedInUser.last_active,
      userGroupId: loggedInUser.group_id,
      accountId: loggedInUser.account_id,
      region: this.getRegion(apiUrl),
    };
    TagManager.dataLayer({ dataLayer });
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    GeckoSocket.removeListener('conversation:created', newConversation);
    GeckoSocket.removeListener('conversation:updated', updateConversation);
    GeckoSocket.removeListener('contacts:merged', handleMergedContacts);
    GeckoSocket.removeListener('disconnect', this.props.userWasDisconnected);
    GeckoSocket.removeListener('reconnect', this.props.userWasDisconnected);
    GeckoSocket.removeListener('connect', this.props.userWasConnected);
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    const { loggedInUser, userGroup, apiUrl } = this.props;
    const region = this.getRegion(apiUrl);
    // identifies user for fullstory //
    if (
      loggedInUser.full_name !== prevProps.loggedInUser.full_name ||
      loggedInUser.email === prevProps.loggedInUser.email
    ) {
      window.FS.identify(loggedInUser.full_name, {
        displayName: loggedInUser.full_name,
        email: loggedInUser.email,
      });
    }
    if (
      prevProps.loggedInUser.full_name !== loggedInUser.full_name ||
      prevProps.loggedInUser.email !== loggedInUser.email ||
      prevProps.loggedInUser.tel !== loggedInUser.tel ||
      prevProps.userGroup !== userGroup
    ) {
      SetupWidgets(region);
    }
  }

  getRegion = (apiUrl) => {
    return apiUrl.indexOf('https://api-eu') === 0 ? 'EU' : 'US'; // but what about localhost?
  };

  handleClickOutside = (e) => {
    if (
      !this.state.menuIsOpen ||
      e.target === '<span></span>' ||
      this.appNavMenu.current.contains(e.target)
    )
      return;
    this.setState({ menuIsOpen: false });
    return this.closeMenu();
  };

  toggleMenu() {
    const that = this;
    this.setState(
      { menuIsOpen: !this.state.menuIsOpen, disableMenuButton: true },
      () => {
        setTimeout(function () {
          that.setState({ disableMenuButton: false });
        }, 500);
      }
    );
  }

  closeMenu() {
    const that = this;
    this.setState({ menuIsOpen: false, disableMenuButton: true }, () => {
      setTimeout(function () {
        that.setState({ disableMenuButton: false });
      }, 500);
    });
  }

  updateUserAvailability(user) {
    UserAvailability.updateUserAvailability(user).catch(renderError);
    this.props.setLoggedInUser(user);
  }

  getStatusBadgeColour(agent) {
    if (agent.presence === 'Online') {
      return agent.web_available || agent.mobile_available
        ? '#5E9E0A'
        : '#F7A700';
    } else {
      return '#D4D4D4';
    }
  }

  openAccountSwitcher() {
    new GeckoModalService().open(() => {
      return <AccountSwitcherModal />;
    });
  }

  openAvailabilityModal() {
    const loggedInUserId = this.props.loggedInUser.id;
    const { admin, agent, createdAt } = this.props.activityPayload;
    const readableDate = moment(createdAt).format('DD/MM/YYYY HH:mm');
    if (agent && agent.id === loggedInUserId) {
      new GeckoModalService()
        .open(
          () => (
            <AvailabilityModal
              adminFullName={admin?.full_name}
              timestamp={readableDate}
              user={this.props.loggedInUser}
            />
          ),
          { size: 'md' }
        )
        .then(() => this.props.activityRead());
    }
    return null;
  }

  navBarBackClickHandler() {
    if (this.props.isMessagesActive) {
      return this.props.showChatHeads();
    }
    return this.props.showMessages();
  }

  render() {
    // Agents with recently updated restrictive permissions who have not re-authenticated
    // may still see all contacts, so remove the link just in case.
    const contactPath =
      this.props.loggedInUser.permissions &&
      this.props.loggedInUser.permissions[
        CONSTS.PERMISSIONS.OWNED_CONTACTS_ONLY
      ]
        ? 'mine'
        : 'all';
    return (
      <div>
        {this.openAvailabilityModal()}
        <div
          className={`AppWrapper ${
            !this.props.loggedInUser.web_available ? 'unavailable' : ''
          }`}
        >
          <div id="AppNavMenu" ref={this.appNavMenu}>
            <nav
              className="AppNav main navbar navbar-expand-sm navbar-inverse"
              role="navigation"
            >
              <button
                className={classNames('navbar-back', {
                  'navbar-back--active':
                    this.props.canShowNavBarBack && !this.state.menuIsOpen,
                })}
                type="button"
                onClick={this.navBarBackClickHandler.bind(this)}
              >
                <i className="far fa-chevron-left"></i>
              </button>
              <button
                className={`navbar-toggler ${
                  this.state.menuIsOpen ? 'open' : ''
                }`}
                type="button"
                onClick={
                  !this.state.disableMenuButton
                    ? this.toggleMenu.bind(this)
                    : null
                }
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
              <div
                className={`collapse navbar-collapse ${
                  this.state.menuIsOpen ? 'show' : 'hide'
                }`}
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav main-nav-links mr-auto">
                  <li className="nav-item navbar-brand">
                    <a href="/" style={{ display: 'block' }}>
                      <span>
                        <img src={logo} alt="conversations" className="gary" />
                      </span>
                    </a>
                  </li>
                  <li className="nav-item d-md-none">
                    <div className="list-search-item">
                      <AppSearch onSearch={() => this.closeMenu()} />
                    </div>
                  </li>
                  <li className="nav-item d-md-none">
                    <span
                      onClick={() =>
                        this.updateUserAvailability(this.props.loggedInUser)
                      }
                      className="nav-availability-toggle"
                    >
                      <div className="availability-label dark">
                        <span>
                          {this.props.loggedInUser.web_available
                            ? 'Status: Available'
                            : 'Status: Unavailable'}
                        </span>
                      </div>
                      <div>
                        <div className="gecko-field-type-toggle">
                          <input
                            id={'availability-toggle'}
                            type="checkbox"
                            className="toggle"
                            checked={this.props.loggedInUser.web_available}
                            onChange={() => {}}
                            disabled={false}
                          />
                          <label style={{ cursor: 'pointer' }}></label>
                        </div>
                      </div>
                    </span>
                  </li>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    onClick={this.closeMenu.bind(this)}
                  >
                    <NavLink
                      to="/conversations"
                      exact={true}
                      className={`nav-link ${
                        this.props.hasUnreadMessage ? 'unread-indicator' : ''
                      }`}
                      activeClassName="active"
                    >
                      <i className="far fa-message-lines"></i>
                      <p className="nav-item-text">Conversations</p>
                    </NavLink>
                  </li>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    onClick={this.closeMenu.bind(this)}
                  >
                    <NavLink
                      to={`/contacts/${contactPath}`}
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className="far fa-address-book"></i>
                      <p className="nav-item-text">Contacts</p>
                    </NavLink>
                  </li>
                  <li
                    className="nav-item"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    onClick={this.closeMenu.bind(this)}
                  >
                    <NavLink
                      to="/agents"
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className="far fa-users"></i>
                      <p className="nav-item-text">Agents</p>
                    </NavLink>
                  </li>
                  {GeckoPermissions.memberOf('admin') ||
                  GeckoPermissions.memberOf('supervisor') ? (
                    <li
                      className="nav-item"
                      data-toggle="collapse"
                      data-target="#navbarSupportedContent"
                      onClick={this.closeMenu.bind(this)}
                    >
                      <NavLink
                        to="/automation/workflows"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <i className="far fa-route"></i>
                        <p className="nav-item-text">Workflows</p>
                      </NavLink>
                    </li>
                  ) : null}
                  {!GeckoFeatures.can('chat-bot') ||
                  (GeckoPermissions.memberOf('agent') &&
                    this.props.botTotal === 0) ? null : (
                    <li
                      className="nav-item"
                      data-toggle="collapse"
                      data-target="#navbarSupportedContent"
                      onClick={this.closeMenu.bind(this)}
                    >
                      <NavLink
                        to="/bots"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <i className="far fa-circle-bolt"></i>
                        <p className="nav-item-text">Bots</p>
                      </NavLink>
                    </li>
                  )}
                  {GeckoPermissions.memberOf('admin') ||
                  GeckoPermissions.memberOf('supervisor') ? (
                    <li
                      className="nav-item"
                      data-toggle="collapse"
                      data-target="#navbarSupportedContent"
                      onClick={this.closeMenu.bind(this)}
                    >
                      <NavLink
                        to="/stats/conversations"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <i className="far fa-chart-line"></i>
                        <p className="nav-item-text">Stats</p>
                      </NavLink>
                    </li>
                  ) : null}
                  {GeckoPermissions.memberOf('admin') ||
                  GeckoPermissions.memberOf('supervisor') ? (
                    <li
                      className="nav-item"
                      data-toggle="collapse"
                      data-target="#navbarSupportedContent"
                      onClick={this.closeMenu.bind(this)}
                    >
                      <NavLink
                        to="/settings/channels"
                        className="nav-link"
                        activeClassName="active"
                      >
                        <i className="far fa-cog"></i>
                        <p className="nav-item-text">Settings</p>
                      </NavLink>
                    </li>
                  ) : null}
                </ul>
                <ul
                  className="navbar-nav secondary-nav"
                  style={{ paddingRight: '15px' }}
                >
                  <li className="nav-item d-none d-md-block">
                    <AppSearch onSearch={() => this.closeMenu()} />
                  </li>
                  <li
                    className={`avatar-item nav-item d-none d-md-block dropdown gecko-dropdown`}
                  >
                    <span
                      className="nav-link dropdown-toggle settings-avatar"
                      id="navbarDropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <PresenceBadge
                        presence={getPresence(
                          this.props.loggedInUser.presence,
                          this.props.loggedInUser.web_available ||
                            this.props.loggedInUser.mobile_available
                        )}
                      >
                        <GeckoAvatar
                          color={
                            this.props.loggedInUser.additional.avatar_colour
                          }
                          name={this.props.loggedInUser.full_name}
                          first_name={this.props.loggedInUser.first_name}
                          last_name={this.props.loggedInUser.last_name}
                          bgImage={
                            this.props.loggedInUser.additional
                              .profile_picture_url
                          }
                        />
                      </PresenceBadge>
                    </span>
                    <div
                      style={{ marginTop: '4px', marginRight: '14px' }}
                      className="dropdown-menu gecko-dropdown-menu dropdown-menu-right"
                      aria-labelledby="navbarDropdownMenuLink"
                      data-popper-placement="bottom-end"
                    >
                      <span
                        onClick={() =>
                          this.updateUserAvailability(this.props.loggedInUser)
                        }
                        className="nav-availability-toggle dropdown-item d-flex"
                      >
                        <div className="availability-label">
                          <span>
                            {this.props.loggedInUser.web_available
                              ? 'Status: Available'
                              : 'Status: Unavailable'}
                          </span>
                        </div>
                        <div>
                          <div className="gecko-field-type-toggle">
                            <input
                              id={'availability-toggle'}
                              type="checkbox"
                              className="toggle"
                              checked={this.props.loggedInUser.web_available}
                              onChange={() => {}}
                              disabled={false}
                            />
                            <label style={{ cursor: 'pointer' }}></label>
                          </div>
                        </div>
                      </span>

                      <hr
                        style={{ height: '1px' }}
                        className="dropdown-divider"
                      ></hr>

                      {!AccountSwitcher.isSwitchedIntoAccount() ? (
                        <NavLink
                          to={`/agents/${this.props.loggedInUser.id}`}
                          className="dropdown-item"
                          activeClassName="active"
                        >
                          Agent Settings
                        </NavLink>
                      ) : null}
                      <span
                        className="dropdown-item"
                        onClick={() => {
                          window.location.href = `${process.env.REACT_APP_AUTH_URL}/account`;
                          return null;
                        }}
                      >
                        Security Preferences
                      </span>
                      {this.props.profiles > 1 ? (
                        <span
                          className="dropdown-item"
                          onClick={() => {
                            window.location.href = `${process.env.REACT_APP_AUTH_URL}/select-profile`;
                            return null;
                          }}
                        >
                          My Accounts
                        </span>
                      ) : null}
                      <span
                        className="dropdown-item"
                        onClick={() =>
                          window.open('https://status.geckochat.io', '_blank')
                        }
                      >
                        Service Status
                      </span>

                      <span
                        className="dropdown-item"
                        onClick={() =>
                          window.open(
                            'https://academy.geckoengage.com/en/',
                            '_blank'
                          )
                        }
                      >
                        Gecko Academy
                      </span>

                      <span
                        onClick={() => window.Intercom('show')}
                        className="dropdown-item"
                      >
                        Contact Support
                      </span>

                      {process.env.NODE_ENV === 'production' && (
                        <span
                          onClick={() => {
                            window.open(
                              'https://calendly.com/d/ckw7-gnt-vrs/user-feedback',
                              '_blank'
                            );
                          }}
                          className="dropdown-item"
                        >
                          Product Feedback
                        </span>
                      )}

                      <hr
                        style={{ height: '1px' }}
                        className="dropdown-divider"
                      ></hr>

                      <NavLink
                        to="/logout"
                        className="dropdown-item logout-btn"
                        activeClassName="active"
                      >
                        Logout
                      </NavLink>
                      {AccountSwitcher.canSwitch() ? (
                        <NavLink
                          to="/admin/"
                          className="dropdown-item"
                          activeClassName="active"
                        >
                          Manage Accounts
                        </NavLink>
                      ) : null}
                      {AccountSwitcher.canSwitch() ? (
                        <span
                          onClick={this.openAccountSwitcher.bind(this)}
                          className="dropdown-item"
                          activeClassName="active"
                        >
                          Internal Account Switcher
                        </span>
                      ) : null}
                      {AccountSwitcher.isSwitchedIntoAccount() ? (
                        <span
                          onClick={AccountSwitcher.restoreOriginal}
                          className="dropdown-item"
                          activeClassName="active"
                        >
                          Own Account
                        </span>
                      ) : null}
                    </div>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div
            className={`AppContentContainer clearfix ${
              this.props.loggedInUser.web_available ? '' : 'unavailable'
            }`}
          >
            <AppSearchResults></AppSearchResults>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

App.childContextTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
};

const getUserGroup = (state) => {
  const { appState, groups } = state;
  const { loggedInUser } = appState;
  if (!loggedInUser) {
    return 'User';
  }
  const group = groups.find((group) => group.id === loggedInUser.group_id);
  if (!group) {
    return 'User';
  }
  return group.type;
};

const mapStateToProps = (state) => {
  return {
    loggedInAccount: state.appState.account,
    profiles: state.appState.profiles,
    loggedInUser: state.appState.loggedInUser,
    apiUrl: state.appState.apiUrl,
    defaultHeaders: state.appState.defaultHeaders,
    searchIsOpen: state.searchResults.isOpen,
    groups: state.groups,
    hasUnreadMessage: !!(
      state.conversationsRoute.myConversations.unreadIds.length ||
      state.conversationsRoute.unassignedConversations.unreadIds.length
    ),
    botTotal: state.botsRoute.bots.total,
    userGroup: getUserGroup(state),
    canShowNavBarBack: getShowNavBarBack(state),
    isMessagesActive: getMessagesActive(state),
    hasAdminChangedAvailability: state.appState.hasAdminChangedAvailability,
    activityPayload: state.appState.activityPayload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoggedInUser: (user) => dispatch(setLoggedInUser(user)),
    userWasConnected: () => dispatch(userWasConnected()),
    userWasDisconnected: () => dispatch(userWasDisconnected()),
    showMessages: () => dispatch(showMessages()),
    showChatHeads: () => dispatch(showChatHeads()),
    activityRead: () => dispatch({ type: 'AVAILABILITY_ACTIVITY_READ' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { pure: false } // So that React Router can still work
)(App);
